import ConfirmModalReducer from "@common/redux/reducers/ConfirmModalReducer";
import BaseAction from "./BaseAction";

class ConfirmModalAction extends BaseAction {
  onClose = () => {};

  onConfirm = () => {};

  open = async (
    message,
    title = "Error",
    onConfirm = () => {},
    onClose = () => {},
    data = {},
  ) => {
    this.onClose = onClose;
    this.onConfirm = onConfirm;
    this.dispatch({ open: true, message, title, ...data });
  };
}

const action = new ConfirmModalAction(ConfirmModalReducer);

export default action;
